import { Check, X, Backpack } from "lucide-react";
import { WHAT_TO_BRING } from "@/lib/tours";
import Reveal from "@/components/landing/Reveal";

const Block = ({ title, accent, children }) => (
  <div className="rounded-2xl border border-white/10 bg-[#161B22] p-7">
    <p className={`font-mono text-[10px] font-semibold uppercase tracking-[0.2em] ${accent ? "text-amber-400" : "text-stone-500"}`}>
      {title}
    </p>
    {children}
  </div>
);

export default function TourIncluded({ tour }) {
  return (
    <section className="border-y border-white/10 bg-[#161B22]/40">
      <div className="mx-auto max-w-7xl px-5 py-20 sm:px-8 sm:py-28">
        <Reveal>
          <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-amber-400">
            Detalhes
          </p>
          <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight tracking-tight text-stone-50 sm:text-4xl">
            Tudo o que você{" "}
            <em className="font-accent font-medium italic text-amber-400">precisa saber.</em>
          </h2>
        </Reveal>

        <div className="mt-12 grid gap-5 md:grid-cols-3">
          <Reveal delay={0}>
            <Block title="Incluso" accent>
              <ul data-testid="tour-included-list" className="mt-4 space-y-2.5">
                {tour.included.map((item) => (
                  <li key={item} className="flex items-start gap-2.5 text-sm leading-relaxed text-stone-200">
                    <Check className="mt-0.5 h-4 w-4 shrink-0 text-emerald-400" />
                    {item}
                  </li>
                ))}
              </ul>
            </Block>
          </Reveal>
          <Reveal delay={0.1}>
            <Block title="Não incluso">
              <ul data-testid="tour-not-included-list" className="mt-4 space-y-2.5">
                {tour.notIncluded.map((item) => (
                  <li key={item} className="flex items-start gap-2.5 text-sm leading-relaxed text-stone-400">
                    <X className="mt-0.5 h-4 w-4 shrink-0 text-stone-500" />
                    {item}
                  </li>
                ))}
              </ul>
              <p className="mt-5 text-xs leading-relaxed text-stone-500">
                Dificuldade: fácil. Passeio acessível para todas as idades.
              </p>
            </Block>
          </Reveal>
          <Reveal delay={0.2}>
            <Block title="O que levar" accent>
              <div data-testid="tour-bring-list" className="mt-4 flex flex-wrap gap-2">
                {WHAT_TO_BRING.map((item) => (
                  <span key={item} className="flex items-center gap-1.5 rounded-full border border-white/10 px-3 py-1.5 text-xs text-stone-300">
                    <Backpack className="h-3 w-3 text-amber-400/70" />
                    {item}
                  </span>
                ))}
              </div>
            </Block>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
